<template>
  <div class="box">
    <div class="study-ul" v-if="list2.length > 0">
      <div class="study-li" v-for="(item, index) in list2" :key="index" @click="onClickRoute(item)">
        <div class="study-video">
          <img v-if="active != 'Live_broadcast' && item.image && item.image.url != undefined" :src="item.image.url" />
          <img class="course-img-empty" v-if="active != 'Live_broadcast' && !item.image" src="@/assets/images/logo-img.png" alt="">
          <img v-if="active == 'Live_broadcast' && item.detailImage && item.detailImage.url != undefined" :src="item.detailImage.url" alt="直播封面" />
          <img class="course-img-empty" v-if="active == 'Live_broadcast' && !item.detailImage" src="@/assets/images/logo-img.png" alt="">
          <div class="video-course-duration-format" v-if="active == 'COURSE'">{{ item.courseDurationFormat }}</div>
        </div>
        <div class="study-text">
          <div>
            <div class="study-title">{{ item.title }}</div>
            <div class="study-introduction">{{ item.introduction }}</div>
          </div>
          <div class="study-time">
            <div class="study-left">{{ item.createTimeFormat }}</div>
          </div>
        </div>
      </div>
    </div>
    <empty class="empty-margin" v-if="list2.length <= 0"></empty>
    <el-pagination class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick" />
  </div>
</template>

<script>
import empty from "@/components/empty/index";
import { getPageDetails } from '@/api/home'
export default {
  name: "InProgress",
  components: { empty },
  props: {
    list2: {
      type: Array,
      default: []
    },
    page: {
      type: Object,
      default: () => {
        return {
          number: 1,
          limit: 10,
          total: 0,
        }
      }
    },
    active: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      appPage: {
        NEWS: 'NewsDetails',
        COURSE: 'CourseDetails',
        SCIENCE: 'NewsDetailsTwo',
        GUIDE_CONSENSUS: 'NewsDetailsThree',
      }
    }
  },
  methods: {
    onClickRoute(value) {
      if(this.active == 'NEWS' || this.active == 'SCIENCE') {
        if(value.isForward) {
          this.getPageDetails(value.id)
          window.open(value.h5Url, '_blank')
        }else {
          this.$router.push({ path: `/${this.appPage[this.active]}/${value.id}` });
        }
      }else {
        this.$router.push({ path: `/${this.appPage[this.active]}/${value.id}` });
      }
    },
    // 按 id 查询新闻资讯、质控课程、质控公告
    getPageDetails(id) {
      getPageDetails({
        id: id
      }).then(res => {
      })
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  }
};
</script>

<style scoped lang="less">
.study-li {
  cursor: pointer;
}

.video-course-duration-format {
  position: absolute;
  right: 4px;
  bottom: 4px;
  background: #0000005C;
  color: #FFFFFF;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
  padding: 0 10px;
}

.study-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 82px;
}

.study-title {
  height: 20px !important;
  line-height: 20px !important;
  margin-bottom: 4px !important;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1; /* 控制显示的行数 */
}

.study-introduction {
  color: #737373;
  font-size: 13px;
  line-height: 18px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; /* 控制显示的行数 */
}

/deep/.el-input__inner {
  height: 32px;
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/NewsList.vue